import axios from "axios";

const url = process.env.REACT_APP_API_URL_REGISTER;
const urlFile = process.env.REACT_APP_API_URL_FILE;

export default class PegawaiService {

    getAllDataPegawai() {
        return axios.get(`${url}/data/pegawai`);
    }

    getDataPegawaiByNIP(nip) {
    return axios.get(`${url}/data/pegawai/${nip}`);
    }

    async addDataPegawai(data) {
        try {
            const response = await axios.post(`${url}/data/pegawai`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: error.message };
        }
    }
    async updateDataPegawai(nip, data) {
        try {
            const response = await axios.put(url + `/data/pegawai/${nip}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: error.message };
        }
    }
    deleteDataPegawai(nip) {
    return axios.delete(`${url}/data/pegawai/${nip}`);
    }
    getNamaUPT(kdUpt) {
        return axios.get(url + '/getuptbyid/' + kdUpt)
    }
   getAllUPT() {
    return axios.get(`${url}/allupt`);
    }

    getAllRole(){
        return axios.get(`${url}/data/role`);
    }
}